module.exports = "//static.hsappstatic.net/codemirror/static-5.24/codemirror.css"